import firebase from "../../adapters/firebase"


export const resetPasswordByEmail = (email) => firebase.sendPasswordResetEmail(email)
